import axios from '../../bootstrap';

/**
 * @param {{ post_name: any; save_img: number; incat: any[]; pricat: string; }} odjData
 */
export function axiosBlogCreatePost(odjData) {
    return axios.post('/api/admin/blog/createpost', odjData);
}

/**
 * @param {{ slug_id: any; }} odjData
 */
export function axiosBlogSetHide(odjData) {
    return axios.post('/api/admin/blog/sethide', odjData);
}

// WEX Blog
export function wexBlogList() {
    return axios.get('/api/admin/wex/blog/lists').then(result => result.data);
}

export function wexBlogCategoryList() {
    return axios
        .get('/api/admin/wex/blog/category/lists')
        .then(result => result.data);
}

export function wexBlogCategory() {
    return axios
        .get('/api/admin/wex/blog/category')
        .then(result => result.data);
}

export function wexBlogRecently() {
    return axios
        .get('/api/admin/wex/blog/recently')
        .then(result => result.data);
}
